module.exports = "/static/assets/41f52071ce371c8a792b03b0c1c4c4b0.jpg";